/**
 * Chapitre « Informations » de la page publique d'une association : y a-t-il
 * au moins une tuile à montrer ? DÉFINITION UNIQUE — la page s'en sert pour
 * le lien « Informations » de la barre des sections, le chapitre
 * (AssociationsPageInfoColumn) pour s'afficher ou non : les deux ne doivent
 * jamais diverger (lien vers une ancre absente).
 */
interface InfosAsso {
  full_address: string | null;
  /** Adresse structurée (migration 307) : rue et ville séparées. */
  address_street?: string | null;
  address_city?: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  website: string | null;
  opening_hours: string | Record<string, unknown> | null;
  display?: { show_opening_hours: boolean } | null;
  documents: unknown[];
}

/**
 * Coordonnées (tuile « Contact ») : e-mail, téléphone, site, réseaux.
 * RNA, SIRET et numéro officiel hors France ne s'affichent plus sur la page
 * (Karim 2026-10-26 : inutiles pour le visiteur) ; Google les lit toujours
 * dans les données structurées (useOrganizationSchema, `identifier`).
 */
export function aDesCoordonneesAsso(org: InfosAsso, aDesReseaux: boolean): boolean {
  return !!(
    org.contact_email ||
    org.contact_phone ||
    org.website ||
    aDesReseaux
  );
}

/**
 * Une adresse vaut une tuile « Où nous trouver » si elle dit plus que la
 * ville : une rue (adresse structurée), ou une ancienne adresse en texte libre
 * sans structure. Une adresse réduite à « Montpellier » n'apprend rien — la
 * ville figure déjà dans la fiche d'identité (Karim 28/10/2026 : « retire
 * Informations s'il n'y a rien dedans »).
 */
export function aUneAdresseUtile(org: Pick<InfosAsso, "full_address" | "address_street" | "address_city">): boolean {
  if (!org.full_address?.trim()) return false;
  if (org.address_street?.trim()) return true;
  return !org.address_city;
}

export function aDesInfosAsso(org: InfosAsso, aDesReseaux: boolean): boolean {
  return (
    aUneAdresseUtile(org) ||
    aDesCoordonneesAsso(org, aDesReseaux) ||
    !!(org.opening_hours && org.display?.show_opening_hours) ||
    org.documents.length > 0
  );
}
